import React, { Component, useState } from "react";
import { Modal } from 'react-bootstrap';
import ScannedItems from './ScannedItems.js';
import { useZxing } from "react-zxing";
import _ from 'lodash';

export const SCAN_SCANNING = 'scan-scanning';
export const SCAN_LOADING = 'scan-loading';
export const SCAN_OK = 'scan-ok';
export const SCAN_ERROR = 'scan-error';

class QRScanner extends Component {

  render(){
    // ************************************************************************
    // Inline Styles for total modularization
    // ************************************************************************

    const overlay = {
      position: 'absolute',
      top: '10px',
      backgroundColor: 'rgba(255, 255, 255, 0.30)',
      padding: '0.5em 1em',
      borderRadius: '25px',
      color: 'white'
    };

    const overlayError = _.assign(_.assign({}, overlay),
      {backgroundColor: 'rgba(255, 0, 0, 0.75)'}
    );
    const overlaySuccess = _.assign(_.assign({}, overlay),
      {backgroundColor: 'rgba(85, 185, 85, 0.75)'}
    );
    const overlayLoading = _.assign(_.assign({}, overlay),
      {backgroundColor: 'rgba(33, 150, 243, 0.75)'}
    );

    const closeStyle = {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: '1em',
      // marginTop: '11em'
    };

    const modalBody = {
      backgroundColor: 'black',
      padding: '1em 0'
    };
    const doneButton = {
      color: '#fff',
      backgroundColor: '#5cb85c',
      borderColor: '#5cb85c',
      borderRadius: '4px',
      padding: '0.5em 1.5em'
    };

    // ************************************************************************
    // Status Chip
    // ************************************************************************
    var statusChip = '';
    switch (this.props.scanStatus) {
      case SCAN_SCANNING:
        statusChip = <div style={overlay}>Scanning...</div>;
        break;
      case SCAN_LOADING:
        statusChip =  <div style={overlayLoading}>Loading...</div>;
        break;
      case SCAN_OK:
        statusChip =  <div style={overlaySuccess}>{this.props.scanResult}</div>;
        break;
      case SCAN_ERROR:
        statusChip =  <div style={overlayError}>{this.props.scanResult}</div>;
        break;
      default:
        statusChip = <div style={overlay}>Scanning...</div>;
    }

    // ************************************************************************
    // JSX
    // ************************************************************************
    return (
      <div>
        <Modal backdrop="static" keyboard={true} show={this.props.show}>
          <Modal.Body style={modalBody} bsClass="modal-body p-0 m-0">
            <div style={closeStyle}>
              <span style={doneButton} onClick={this.props.onHide}>
                Done
              </span>
            </div>
            <CameraScanner
              scanStatus={this.props.scanStatus}
              onScan={this.props.onScan}
              onError={this.props.onError}
            />
            {this.props.scannedItems && this.props.scannedItems.length > 0 ? (
              <ScannedItems scannedItems={this.props.scannedItems} />
            ) : null}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

// TODO: nico heavily test this

const camStyle = {
  display: "flex",
  justifyContent: "center",
  position: "relative",
};

const previewStyle = {
  objectFit: "fill",
  width: "100%",
};


const CameraScanner = ({ scanStatus, onScan, onError }) => {
  const [result, setResult] = useState("");
  const { ref } = useZxing({
    onDecodeResult: (result) => {
      const data = result.getText();
      if (data && scanStatus === SCAN_SCANNING) {
        const oldLabelFormat =
          /http:\/\/inventory:8082\/Inventory2\/Action_Pages\/QrScanPage.php?[\W\w]*uniqueid=(\d+)[\W\w]*/;
        let parsedData = data;
        if (oldLabelFormat.test(data)) {
          parsedData = oldLabelFormat.exec(data)[1];
        }
        onScan(parsedData);
        setResult(parsedData); // Store the scanned result
      }
    },
    onError: (error) => {
      if (onError) {
        onError(error);
      }
    },
  });

  return (
    <div style={{ position: "relative", ...camStyle }}>
      <video ref={ref} style={previewStyle} />
      {result && (
        <div style={{ position: "absolute", bottom: 10, left: 10, color: "white" }}>
          Scanned: {result}
        </div>
      )}
    </div>
  );
};

export default QRScanner;
